import { FC, useEffect, useRef, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import {
  CurrencyInput,
  Button,
  Form,
  Grid,
  Input,
  Row,
  SelectForm,
  Span
} from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import useLoading from 'hooks/useLoading'
import Draggable from 'react-draggable'
import { useForm } from 'react-hook-form'
import {
  RolDocumento,
  RolDocumentsServices
} from 'services/NGT/Parameterization'
import { COLORS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'
import * as Yup from 'yup'

import {
  DialogContentStyled,
  DialogTitleStyled,
  RollStamp
} from '../ModalRegisterRollDocs/ModalRegisterRollDocs.styles'
import { useModal } from 'hooks'

interface IModalEditRolDocs {
  showModal: boolean
  toggleModal: () => void
  rolDocSelected: RolDocumento
  onSubmit: (data: any) => void
}

interface IFormType {
  txtTipoDocumento: string
  txtDescDocumento: string
  cdTipoEfetivo: string
  cdStatusEfetivo: string
  cdCalcRisco: string
  cdPeriodicidade: string
  nuIndice: string
  rolPrincipalId: number
  tipoPendenciaId: number
}

const schema = Yup.object({
  cdCalcRisco: Yup.string().required('Campo obrigatório'),
  cdPeriodicidade: Yup.string().required('Campo obrigatório'),
  cdStatusEfetivo: Yup.string().required('Campo obrigatório'),
  cdTipoEfetivo: Yup.string().required('Campo obrigatório'),
  nuIndice: Yup.number().typeError("Digite um numero de 0 a 100").test('Max 0 a 100', "Digite um numero de 0 a 100", (a) => (Number(a) >= 0 && Number(a) <= 100) || a === 0
  ),
  rolPrincipalId: Yup.string().nullable(),
  tipoPendenciaId: Yup.string().required('Campo obrigatório'),
  txtDescDocumento: Yup.string().required('Campo obrigatório'),
  txtTipoDocumento: Yup.string().required('Campo obrigatório')
})

const defaultForm = {
  cdCalcRisco: undefined,
  cdPeriodicidade: undefined,
  cdStatusEfetivo: undefined,
  cdTipoEfetivo: undefined,
  nuIndice: undefined,
  rolPrincipalId: undefined,
  tipoPendenciaId: undefined,
  txtDescDocumento: undefined,
  txtTipoDocumento: undefined
}
const ModalEditRolDocs: FC<IModalEditRolDocs> = ({
  showModal,
  toggleModal,
  onSubmit,
  rolDocSelected
}) => {
  const { setLoading, setMsgErro } = useLoading()
  const [pendenciasModal, setPendenciasModal] = useState<any[] | undefined>()
  const [tipoEfetivoModal, setTipoEfetivoModal] = useState<any[] | undefined>()
  // const [tipoModal, setTipoModal] = useState<string | undefined>()
  const [statusModal, setStatusModal] = useState<any[] | undefined>()
  const [calcRiscoModal, setCalcRiscoModal] = useState<any[] | undefined>()
  const [periodicidadeModal, setPeriodicidadeModal] = useState<
    any[] | undefined
  >()
  const [dependenteModal, setDependenteModal] = useState<any[] | undefined>()
  const [selectDependenteModal, setSelectDependenteModal] = useState<any[]>([])
  const [rolDocumentModal, setRolDocumentModal] = useState<string | undefined>()
  const {
    control,
    watch,
    reset,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm<IFormType>({
    defaultValues: defaultForm,
    resolver: yupResolver(schema)
  })

  const { showModal: showModalUseModal } = useModal()
  // GET DATA

  useEffect(() => {
    const getParams = () => {
      setLoading('loading')
      RolDocumentsServices()
        .getParametrosCDU(rolDocSelected.idRolDocumento)
        .then(({ data }) => {
          if (data.sucesso) {
            data.entity?.forEach((el) => {
              if (el.chave === 'Calculo Risco') {
                setCalcRiscoModal(
                  el.valores.map((el) => ({
                    label: el,
                    value: el
                  }))
                )
              }

              if (el.chave === 'Pendencia') {
                setPendenciasModal(el.valores)
              }

              if (el.chave === 'Periodicidade') {
                setPeriodicidadeModal(
                  el.valores.map((el) => ({
                    label: el,
                    value: el
                  }))
                )
              }

              if (el.chave === 'TipoEfetivo') {
                setTipoEfetivoModal(
                  el.valores.map((el) => ({
                    itens: el.itens,
                    label: el.tipoEfetivo,
                    value: el.tipoEfetivo
                  }))
                )
              }

              if (el.chave === 'Status do Efetivo') {
                setStatusModal(
                  el.valores.map((el) => ({
                    label: el,
                    value: el
                  }))
                )
              }
              if (el.chave === 'Dependente') {
                const dependenteRef = el.valores.find(
                  (el) => el.rol === rolDocSelected.txtTipoDocumento
                )
                setDependenteModal(el.valores)
                setRolDocumentModal(dependenteRef?.rol)
                setSelectDependenteModal(dependenteRef?.itens || [])
              }
            })
          }
          setLoading('idle')
        })
        .catch((err) => {
          // setMsgErro(err)
          // setLoading('error')
          setLoading('idle')
          showModalUseModal({
            hideButtonCancel: true,
            message: err,
            type: 'error'
          })
        })
    }
    getParams()
  }, [])

  // ! LISTENER FORM

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === 'tipoPendenciaId') {
        const index = pendenciasModal?.findIndex(
          (el) => el.idTipoPendencia === value.tipoPendenciaId
        )
        index && setValue('txtTipoDocumento', pendenciasModal[index]?.txTipo)
        index === 0 &&
          setValue('txtTipoDocumento', pendenciasModal[index]?.txTipo)
        return
      }

      if (name === 'cdTipoEfetivo') {
        //BUSCA QUAL ROL E O TIPO EFETIVO
        const refTipo = tipoEfetivoModal?.find(
          (el) => el.value === value.cdTipoEfetivo
        )
        // BUSCA LISTA DEPENDENTES DE ACORDO COM O ROL
        const refDep = dependenteModal?.find(
          (el) => el.rol === refTipo?.itens[0]?.rol
        )
        //TROCA LISTA DO SELECT
        setSelectDependenteModal(refDep?.itens)
        //TROCA NUMERO ROL MODAL
        setRolDocumentModal(refDep.rol)
        return
      }
    })
    return () => subscription.unsubscribe()
  }, [watch, tipoEfetivoModal, dependenteModal])

  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      reference={draggableReference}
      showModal={showModal}
      onClose={toggleModal}
      width={'md'}
    >
      <DialogTitleStyled>Editar Item Rol de Documentos</DialogTitleStyled>
      <DialogContentStyled>
        <Form
          onSubmit={(submitData) => {
            handleSubmit(onSubmit)(submitData).then(() => {
              resetModalState(draggableReference)
            })
          }}
        >
          <Grid
            gridCols="2fr 1fr 4fr .05fr .5fr"
            gridGap={`0 ${SPACING.spacing15}`}
            margin={`${SPACING.spacing20} 0 ${SPACING.spacing20} 0`}
          >
            <SelectForm
              defaultValue={rolDocSelected.tipoPendenciaId}
              listOptions={pendenciasModal}
              label="Pendência"
              placeholder="Selecione"
              errors={errors}
              labelMenu="txDescricao"
              valueMenu="idTipoPendencia"
              formValue="tipoPendenciaId"
              control={control}
            />
            <Input
              defaultValue={rolDocSelected.tipoPendencia}
              control={control}
              errors={errors}
              formValue="txtTipoDocumento"
              disabled
              label="Tipo"
              placeholder="Tipo"
            />
            <Input
              defaultValue={rolDocSelected.txtDescDocumento}
              formValue="txtDescDocumento"
              label="Descrição"
              placeholder="Descrição"
              errors={errors}
              control={control}
            />
            <div />
            <RollStamp>
              <Span
                textAlign="center"
                text={`ROL ${rolDocumentModal || '0'}`}
                color={COLORS.black}
                fontSize={TYPOGRAPHY.subtitleSize20}
              />
            </RollStamp>
          </Grid>
          <Grid
            gridCols="1.2fr 1.2fr 1.2fr 1.2fr 1.2fr 1.2fr 0.8fr"
            gridGap={`0 ${SPACING.spacing15}`}
            margin={`${SPACING.spacing5} 0 ${SPACING.spacing20} 0`}
          >
            <SelectForm
              defaultValue={rolDocSelected.cdTipoEfetivo}
              listOptions={tipoEfetivoModal}
              label="Tipo Efetivo"
              placeholder="Selecione"
              formValue="cdTipoEfetivo"
              control={control}
              errors={errors}
            />
            <SelectForm
              defaultValue={rolDocSelected.cdStatusEfetivo}
              listOptions={statusModal}
              label="Status do Efetivo"
              placeholder="Selecione"
              formValue="cdStatusEfetivo"
              control={control}
              errors={errors}
            />
            <SelectForm
              defaultValue={rolDocSelected.cdCalcRisco}
              listOptions={calcRiscoModal}
              label="Cálculo de Risco"
              placeholder="Selecione"
              formValue="cdCalcRisco"
              control={control}
              errors={errors}
            />
            <CurrencyInput
              defaultValue={rolDocSelected.nuIndice?.toString() || ''}
              formValue="nuIndice"
              label="Índice (%)"
              style="percent"
              control={control}
              errors={errors}
              maxLength={6}
            />
            <SelectForm
              defaultValue={rolDocSelected.cdPeriodicidade}
              control={control}
              errors={errors}
              formValue="cdPeriodicidade"
              listOptions={periodicidadeModal}
              label="Periodicidade"
              placeholder="Selecione"
            />
            <SelectForm
              defaultValue={rolDocSelected.rolPrincipalId || 'Não'}
              listOptions={FORMAT.orderByPropValue(
                [{ dependente: 'Não', id: 'Não' }, ...selectDependenteModal],
                'dependente'
              )}
              formValue="rolPrincipalId"
              label="Dependente"
              placeholder="Qtd."
              labelMenu="dependente"
              valueMenu="id"
              control={control}
              errors={errors}
            />
          </Grid>

          <Row justifyContent="flex-end" marginTop={SPACING.spacing50}>
            <Button
              text="Limpar"
              variantButton="text"
              onClick={() =>
                reset({
                  cdCalcRisco: '',
                  cdPeriodicidade: '',
                  cdStatusEfetivo: '',
                  cdTipoEfetivo: '',
                  nuIndice: '',
                  rolPrincipalId: null,
                  tipoPendenciaId: rolDocSelected.tipoPendenciaId,
                  txtDescDocumento: ''
                })
              }
            />
            <Button
              text="Voltar"
              variantButton="outlined"
              onClick={() => {
                resetModalState(draggableReference)
                toggleModal()
              }}
              marginLeft={SPACING.spacing15}
            />
            <Button
              text="Salvar"
              type="submit"
              marginLeft={SPACING.spacing15}
            />
          </Row>
        </Form>
      </DialogContentStyled>
    </DraggableDialog>
  )
}

export default ModalEditRolDocs
